import { useNavigate, useParams } from 'react-router-dom';
import { Calendar, Mail } from 'lucide-react';
import { jwtDecode } from 'jwt-decode';
import { useGoogleLogin } from "@react-oauth/google";
import axios from 'axios';

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

const SCOPES = [
  'https://www.googleapis.com/auth/calendar.readonly',
];

export function MentorCalendarConnect() {
  const { sessionId, mentorId } = useParams();
  const navigate = useNavigate();

   const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      console.log('Google login success:', tokenResponse);
      sessionStorage.setItem("googleAccessToken", tokenResponse.access_token)
      
      // Fetch user info
      try {
        const userInfoResponse = await axios.get(
          'https://www.googleapis.com/oauth2/v3/userinfo',
          {
            headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
          }
        );
        sessionStorage.setItem("googleUserInfo", userInfoResponse.data)
       navigate(`/find-time/${sessionId}/mentor/${mentorId}/availability`);
      } catch (error) {
        console.error('Error fetching user info:', error);
      }
    },
    onError: (error) => {
      console.error('Login Failed:', error);
    },
    scope: 'https://www.googleapis.com/auth/calendar.readonly',
  });

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <div className="bg-white rounded-lg shadow-sm border p-8 text-center">
        <div className="mb-8">
          <Calendar className="w-16 h-16 text-[#ffcc32] mx-auto mb-4" />
          <h1 className="text-2xl font-bold mb-4">Connect Your Calendar</h1>
          <p className="text-gray-600 mb-6">
            Connect your calendar to automatically find available time slots for mentorship sessions.
            We'll look for open spaces and slots marked as
          </p>
          <p>[VINCER] Landing Zone.</p>
        </div>

        <div className="space-y-4 flex flex-col items-center">
            <div className="text-center">
              <button
                onClick={() => login()}
                className="px-4 py-2 border flex gap-2 border-slate-200 rounded-lg text-slate-700 hover:border-slate-400 hover:text-slate-900 hover:shadow transition duration-150"
              >
                <img
                  className="w-6 h-6"
                  src="https://www.svgrepo.com/show/475656/google-color.svg"
                  loading="lazy"
                  alt="Google logo"
                />
                <span>Login with Google</span>
              </button>
            </div>
        </div>
      </div>
    </div>
  );
}